<template>
  <div id="view">
    <!-- 顶部起始位置 -->
    <historyTag :historyArr="historyArr"></historyTag>
    <!-- 顶部结束位置 -->

    <div id="mainBox">
      <!-- 列表 -->
      <div class="bannerList" v-show="pageShow == 'index'">
        <!-- 顶部起始位置 -->
        <div class="topBox flex">
          <ul class="flex">
            <li class="flex">
              <div style="width: 200px">
                <el-select v-model="searchType" placeholder="请选择类型" clearable style="width: 100%">
                  <el-option label="贡献品牌批号生产日期" :value="1"></el-option>
                  <el-option label="提交品牌批号" :value="2"></el-option>
                </el-select>
              </div>
            </li>
            <li class="flex" style="margin-left:15px">
              <div style="width: 150px">
                <el-select v-model="searchStatus" placeholder="请选择状态" clearable style="width: 100%">
                  <el-option label="无效" :value="0"></el-option>
                  <el-option label="有效" :value="1"></el-option>
                </el-select>
              </div>
            </li>
            <li class="flex" style="margin-left:15px">
              <el-button type="success" size="small" @click="searchFn">搜索</el-button>
            </li>
            <li class="flex" style="margin-left:15px">
              <el-button type="info" size="small" @click="resetFn">重置</el-button>
            </li>
          </ul>
          <!-- <el-button type="success" size="small" @click="addFn">新增</el-button> -->
        </div>
        <!-- 顶部结束位置 -->

        <div class="table-scroll-wrap">
          <el-table border :data="tableData" style="width: 100%">
            <!-- <el-table-column prop="id" align="center" label="ID" width="80">
            </el-table-column> -->
            <el-table-column prop="nickName" align="center" label="贡献用户">
            </el-table-column>
            <el-table-column prop="brand" align="center" label="品牌名">
            </el-table-column>
            <el-table-column prop="batchNumber" align="center" label="批号">
            </el-table-column>

            <!-- <el-table-column prop="productName" align="center" label="产品名称">
            </el-table-column> -->

            <el-table-column align="center" label="类型" width="180">
              <template slot-scope="scope">
                <span>{{ scope.row.type == 1 ? '贡献品牌批号生产日期' : scope.row.type == 2 ? '提交品牌批号' : '' }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="expiryDate" align="center" label="过期日期" width="180">
            </el-table-column>

            <el-table-column align="center" label="是否有效" width="100">
              <template slot-scope="scope">
                <span>{{ scope.row.status == 1 ? '有效' : '无效' }}</span>
              </template>
            </el-table-column>

            <!-- <el-table-column align="center" label="是否已开封" width="120">
              <template slot-scope="scope">
                <span>{{ scope.row.isOpened == 1 ? '是' : '否' }}</span>
              </template>
            </el-table-column> -->
            <el-table-column prop="createTime" align="center" label="创建时间" width="180">
            </el-table-column>
            <el-table-column align="center" label="操作" width="250">
              <template slot-scope="scope">
                <el-button v-if="scope.row.status == 0" type="success" size="small" @click="setValidFn(scope.$index)">设为有效</el-button>
                <!-- <el-button type="success" size="small" @click="editFn(scope.$index)">编辑</el-button> -->
                <el-button type="danger" size="small" @click="delFn(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <list-pagination
          :total="tableTotal"
          :current-page.sync="currentPage"
          :page-size.sync="pageSize"
          @page-change="changePage"
          @size-change="handlePageSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { delTips, throttle, returnTime } from "@/util/utils";
export default {
  data() {
    return {
      // 历史记录
      historyArr: ["批号查询管理", "贡献批号表"],

      // 搜索
      searchType: "",
      searchStatus: "",

      currentPage: 1,
      pageSize: 10,
      tableTotal: 0,
      pageShow: "index",
      tableData: [],
    };
  },
  created() { },
  mounted() {
    this.selListFn(1); //查询
  },
  methods: {
    // 分页
    changePage: function (page) {
      this.selListFn(page)
    },

    handlePageSizeChange() {
      this.selListFn(this.currentPage);
    },

    // 搜索
    searchFn: function (res) {
      this.selListFn(1)
    },

    // 重置
    resetFn: function () {
      this.searchType = "";
      this.searchStatus = "";
      this.currentPage = 1;
      this.selListFn(1);
    },

    // 查询
    selListFn: function (page) {
      if (page) {
        this.currentPage = page;
      }
      var obj = {
        page: this.currentPage || 1,
        size: this.pageSize
      };

      if (this.searchType !== "" && this.searchType !== null && this.searchType !== undefined) {
        obj.type = this.searchType;
      }
      if (this.searchStatus !== "" && this.searchStatus !== null && this.searchStatus !== undefined) {
        obj.status = this.searchStatus;
      }

      this.$https(this.$api.api.selUserContributionBatch, obj, "GET").then((res) => {
        if (res.data.code == 200) {
          var data = res.data.data || [];
          // 格式化时间
          data.forEach((v) => {
            if (v.createTime) {
              v.createTime = returnTime(new Date(v.createTime), "-", "s");
            }
            if (v.expiryDate) {
              v.expiryDate = returnTime(new Date(v.expiryDate), "-");
            }
            if (v.productionDate) {
              v.productionDate = returnTime(new Date(v.productionDate), "-", "s");
            }
            if (v.openDate) {
              v.openDate = returnTime(new Date(v.openDate), "-", "s");
            }
            if (v.openExpiryDate) {
              v.openExpiryDate = returnTime(new Date(v.openExpiryDate), "-", "s");
            }
          });
          this.tableData = data;
          this.tableTotal = res.data.size || 0;
        } else {
          this.tableData = [];
          this.tableTotal = 0;
          this.$message.error(res.data.msg || "查询失败");
        }
      });
    },

    // 新增
    addFn: function (res) {
      // TODO: 实现新增功能
      this.$message.info("新增功能待实现");
    },

    // 删除
    delFn: delTips(function (index) {
      var list = this.tableData[index];
      if (!list || !list.id) {
        this.$message.error("记录信息不完整");
        return;
      }

      var url = this.$api.api.removeUserContributionBatch + list.id;
      this.$https(url, {}, "POST").then((res) => {
        if (res.data.code == 200) {
          this.$message.success("删除成功");
          this.selListFn(this.currentPage);
        } else {
          this.$message.error(res.data.msg || "删除失败");
        }
      });
    }),

    // 编辑
    editFn: function (index) {
      var list = this.tableData[index];
      // TODO: 实现编辑功能
      this.$message.info("编辑功能待实现");
    },

    // 设为有效
    setValidFn: function (index) {
      var list = this.tableData[index];
      if (!list || !list.id) {
        this.$message.error("记录信息不完整");
        return;
      }

      var obj = {
        id: list.id,
        status: 1
      };

      this.$https(this.$api.api.updateUserContributionBatch, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          this.$message.success("操作成功");
          this.selListFn(this.currentPage);
        } else {
          this.$message.error(res.data.msg || "操作失败");
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
#mainBox {
  width: 100%;
  padding: 15px;
  box-sizing: border-box;

  // 头部
  .topBox {
    width: 100%;
    margin-bottom: 10px;
    text-align: right;
    justify-content: space-between;
  }

  .bannerList {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/batchQuery/contributionBatchTable.vue